import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Registration from '../views/Registration.vue'
import Checkout from '../views/Checkout.vue'
import Tutorial from '../views/Tutorial.vue'
import Success from '../views/Success.vue'
import Cancel from '../views/Cancel.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/registration',
    name: 'Registration',
    component: Registration
  },
  {
    path: '/checkout',
    name: 'Checkout',
    component: Checkout
  },
  {
    path: '/test',
    name: "test",
    component: Tutorial
  },
  {
    path: '/success/:id',
    name: 'success',
    component: Success
  },
  {
    path: '/cancel',
    name: 'Cancel Payment',
    component: Cancel
  },
  {
    path: '*',
    redirect: to => {
      window.location.href = 'https://www.sv.camp';
    }
  }
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  routes
})

export default router
